export default "__VITE_ASSET__DF4_eVMp__"